import { render, staticRenderFns } from "./NewPublicacion.vue?vue&type=template&id=0ea76316&scoped=true"
import script from "./NewPublicacion.vue?vue&type=script&lang=ts"
export * from "./NewPublicacion.vue?vue&type=script&lang=ts"
import style1 from "./NewPublicacion.vue?vue&type=style&index=1&id=0ea76316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea76316",
  null
  
)

export default component.exports